import { axios, axiosWithTimeOut } from '../utilities/axios';

const baseKongUrl = `${process.env.CVNA_APP_KONG_URL}/core/headerapi/api`;

class HeaderApi {
  static fetchTrade() {
    return axios.get(`${baseKongUrl}/v2/trade`, { timeout: 10000 }).then(res => res.data);
  }

  static fetchHeaderWithAuthV2(url) {
    return axios.get(`${baseKongUrl}/v2/${url}`).then(res => res.data);
  }

  static fetchHeader(url) {
    return axios.get(`${baseKongUrl}/v1/${url}`).then(res => res.data);
  }

  static fetchHeaderWithAuth(url) {
    return axios.get(`${baseKongUrl}/v1/${url}`).then(res => res.data);
  }

  static fetchHeaderWithAuthWithExtendedTimeout(url) {
    return axiosWithTimeOut(6000)
      .get(`${baseKongUrl}/v1/${url}`)
      .then(res => res.data);
  }

  static fetchAppSettings(settings) {
    const queryParams = settings.map(setting => `keys=${setting}`).join('&');
    return axiosWithTimeOut(5000)
      .get(`${baseKongUrl}/v1/settings?${queryParams}`)
      .then(res => {
        return res.data;
      });
  }
}

export default HeaderApi;
